import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import Protected from "@/components/Protected";

const PlatformConsole = lazy(() => import("@/pages/PlatformConsole"));
const HotelOnboardWizard = lazy(() => import("@/pages/HotelOnboardWizard"));
const AdminUsers = lazy(() => import("@/pages/AdminUsers"));

const A = ["platform_admin"];

/**
 * One console, one address per job. Everything the platform operator can do
 * lives under /platform/<section>/<screen>; the old one-screen-per-capability
 * URLs redirect into the section that now owns that work.
 */
export default (
  <>
    <Route path="/platform" element={<Protected roles={A}><PlatformConsole /></Protected>} />
    <Route path="/platform/:section" element={<Protected roles={A}><PlatformConsole /></Protected>} />
    <Route path="/platform/:section/:screen" element={<Protected roles={A}><PlatformConsole /></Protected>} />

    {/* Surfaces that are a flow rather than a console screen. */}
    <Route path="/platform/hotels/onboard" element={<Protected roles={A}><HotelOnboardWizard /></Protected>} />
    <Route path="/platform/users" element={<Protected roles={A}><AdminUsers /></Protected>} />

    {/* Retired addresses → the section that now owns the work. */}
    <Route path="/platform/organizations"  element={<Navigate to="/platform/network/people" replace />} />
    <Route path="/platform/doctors"        element={<Navigate to="/platform/network/clinicians" replace />} />
    <Route path="/platform/pharmacies"     element={<Navigate to="/platform/network/partners" replace />} />
    <Route path="/platform/laboratories"   element={<Navigate to="/platform/network/partners" replace />} />
    <Route path="/platform/countries"      element={<Navigate to="/platform/system/countries" replace />} />
    <Route path="/platform/configuration"  element={<Navigate to="/platform/system/flags" replace />} />
    <Route path="/platform/finance"        element={<Navigate to="/platform/commerce/payouts" replace />} />
    <Route path="/platform/compliance"     element={<Navigate to="/platform/governance/audit" replace />} />
    <Route path="/admin/dsar"              element={<Navigate to="/platform/governance/privacy" replace />} />
    <Route path="/admin/retention"         element={<Navigate to="/platform/governance/retention" replace />} />
    <Route path="/admin/audit"             element={<Navigate to="/platform/governance/audit" replace />} />
    <Route path="/admin/classification"    element={<Navigate to="/platform/governance/classification" replace />} />
  </>
);
